(function () {
  function onReady(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback);
      return;
    }

    callback();
  }

  function submitForm(form) {
    if (!form) return;

    if (typeof form.requestSubmit === "function") {
      form.requestSubmit();
      return;
    }

    form.submit();
  }

  function getStoredView() {
    try {
      return window.localStorage.getItem("bn-collection-view");
    } catch (error) {
      return null;
    }
  }

  function storeView(view) {
    try {
      window.localStorage.setItem("bn-collection-view", view);
    } catch (error) {
      return;
    }
  }

  function setView(root, view) {
    var results = root.querySelector("[data-bn-collection-results]");
    var buttons = Array.prototype.slice.call(root.querySelectorAll("[data-bn-view-toggle]"));

    if (results) {
      results.setAttribute("data-view", view);
    }

    buttons.forEach(function (button) {
      var isActive = button.getAttribute("data-bn-view-toggle") === view;
      button.classList.toggle("is-active", isActive);
      button.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  }

  function initCollection(root) {
    var form = root.querySelector("[data-bn-collection-form]");
    var buttons = Array.prototype.slice.call(root.querySelectorAll("[data-bn-view-toggle]"));
    var autoSubmitInputs = Array.prototype.slice.call(root.querySelectorAll("[data-bn-auto-submit]"));
    var preferredView = getStoredView();

    setView(root, preferredView === "list" ? "list" : "grid");

    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        var view = button.getAttribute("data-bn-view-toggle");
        setView(root, view);
        storeView(view);
      });
    });

    autoSubmitInputs.forEach(function (input) {
      input.addEventListener("change", function () {
        submitForm(form);
      });
    });
  }

  onReady(function () {
    Array.prototype.slice.call(document.querySelectorAll("[data-bn-collection]")).forEach(initCollection);
  });
})();
